<template>
  <vs-wrapper v-if="isInputFormShowing">
    <vs-heading type="subhead">Create a new project</vs-heading>
    <vs-wrapper space="small">
      <vs-form ref="projectForm">
        <vs-text-input
          data-test="name-input-field"
          :value="input"
          label="Name"
          required
          autofocus
          @input="onInputChange"
        />
      </vs-form>

      <v-row no-gutters justify="end" align="center" class="mt-3">
        <vs-button
          data-test="create-project"
          label="Save"
          :loading="isSaving"
          @click="onSaveClick"
        />
      </v-row>
    </vs-wrapper>
  </vs-wrapper>
  <vs-button
    v-else
    data-test="toggle"
    label="New project"
    full-width
    @click="toggleCreateProjectForm(false)"
  />
</template>

<script setup lang="ts">
import { ref } from 'vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsHeading from '@/components/vision/VsHeading.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsForm from '@/components/vision/VsForm.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import { ProjectCreationComponent } from './ProjectCreationComponent'

const emit = defineEmits(['input-change'])

defineProps<{
  input: string
}>()

const projectForm = ref(null)
const projectName = ref('')
const isInputFormShowing = ref(false)
const isSaving = ref(false)

const onInputChange = (value: string) => {
  emit('input-change', value)
}

const resetForm = () => {
  projectName.value = ''
  isSaving.value = false
  isInputFormShowing.value = false
}

const onSaveClick = () => {
  if (!projectForm.value?.isValid()) {
    return
  }

  isSaving.value = true
}

const stopSaving = () => {
  isSaving.value = false
}

const toggleCreateProjectForm = (value: boolean) => {
  isInputFormShowing.value = !value
}

defineExpose<ProjectCreationComponent>({
  projectName,
  isSaving,
  isInputFormShowing,
  stopSaving,
  resetForm,
})
</script>
